/*
    Description: js subscribe form class
    Author URI: https://destinationsalesandmarketinggroup.com/
    Author: adillice
    Version: 1.0.0
*/

//import utility class for ajax call
import Utilities from "./utilities";

// subscribe form class
class Subscribe extends Utilities{

    // constructor
    constructor(){
        
        // get constructor/params from Utilities
        super();

        // set search overlay title
        this.title = "Subscribe";

        // set submit button aria-label and label
        this.submitAriaLabel = "Press enter or click submit to subscribe";
        this.submitBttnLabel = "Subscribe";

        // set selectors
        this.selectorPrefix = "subscribing";
        this.modalSelector = `${this.selectorPrefix}__modal`;
        this.msgSelector = `${this.selectorPrefix}__form__row__input__msg`,
        this.footerMsgSelector = "modal__wrapper__footer__messages",
        this.loadingBarClassName = "modal__wrapper__footer__loadingbar__bar",
        this.submitID = `${this.selectorPrefix}__submit`;
        this.loadingClassName = "--loading";
        this.successClassName = "--success";
        this.errorClassName = "--error";
        this.hideClassName = "--hide";

    }

    // add content to title
    setTitle(){

        // return title
        return (this.title) ? this.title : null;

    }

    // add content to body
    setBody(){

        // create our row labels
        const rowLabels = [
            {
                "id":`${this.selectorPrefix}__fname`,
                "name":`reportsFirstName`,
                "placeholder":`First Name`,
                "input-aria-label":"Enter your first name to subscribe",
                "msg-aria-label":"Subscribe first name output message area",
            },
            {
                "id":`${this.selectorPrefix}__lname`,
                "name":`reportsLastname`,
                "placeholder":`Last Name`,
                "input-aria-label":"Enter your last name to subscribe",
                "msg-aria-label":"Subscribe last name output message area",
            },
            {
                "id":`${this.selectorPrefix}__email`,
                "name":`reportsEmail`,
                "placeholder":`Email`,
                "input-aria-label":"Enter your email to subscribe",
                "msg-aria-label":"Subscribe email output message area",
            },

        ],
        output =  document.createElement("div"),        // tmp output div for our innerHTML return
        formWrapper = document.createElement("div"),    // form wrapper
        form = document.createElement("form");          // form div

        // add class to form wrapper
        formWrapper.classList.add(`${this.selectorPrefix}`);
        
        // add class to form
        form.classList.add(`${this.selectorPrefix}__form`);

        // create all row dynamically
        for (let i = 0; i < rowLabels.length; i++){

            // create row elements
            const rowWrapper = document.createElement("div"),   //create main row wrapper
            rowSubWrapper = document.createElement("div"),      //create main sub wrapper
            rowLastWrapper = document.createElement("div"),     //create last wrapper for the submit button
            rowInput = document.createElement("input"),         //create row input
            rowMsg = document.createElement("div");             //create row msg area
            
            // add common classes for all rows
            rowWrapper.classList.add(`${this.selectorPrefix}__form__row`);
            rowWrapper.classList.add(`${rowLabels[i].id}__wrapper`);
            rowSubWrapper.classList.add(`${this.selectorPrefix}__form__row__input`);
            rowLastWrapper.classList.add(`${this.selectorPrefix}__form__row__input__wrapper`);
            rowInput.classList.add(`--${this.selectorPrefix}-shadow`);
            rowMsg.classList.add(`${this.selectorPrefix}__form__row__input__msg`);
            
            // add common attributes for all rows
            rowInput.setAttribute("id", rowLabels[i].id);
            rowInput.setAttribute("name", rowLabels[i].name);
            rowInput.setAttribute("placeholder", rowLabels[i].placeholder);
            rowInput.setAttribute("aria-label", rowLabels[i]["input-aria-label"]);
            rowMsg.setAttribute("aria-label", rowLabels[i]["msg-aria-label"]);
            rowMsg.setAttribute("aria-hidden", "true");

            // add submit on last row
            if(i >= (rowLabels.length - 1)){

                // create submit button
                const submitBttn = document.createElement("input");

                // add submit button attributes
                submitBttn.setAttribute("id", this.submitID);
                submitBttn.classList.add(`--${this.selectorPrefix}-shadow`);
                submitBttn.setAttribute("type", "submit");
                submitBttn.setAttribute("value", this.submitBttnLabel);
                submitBttn.setAttribute("aria-label", this.submitAriaLabel);
                
                // add submit button to current rowInput
                rowLastWrapper.appendChild(rowInput);
                rowLastWrapper.appendChild(submitBttn);
                rowWrapper.appendChild(rowLastWrapper);
                rowWrapper.appendChild(rowMsg);
                
            // normaly add elements to row 
            }else{

                // attach elements together
                rowSubWrapper.appendChild(rowInput);
                rowSubWrapper.appendChild(rowMsg);
                rowWrapper.appendChild(rowSubWrapper);

            }
            
            // add to form wrapper
            form.appendChild(rowWrapper);

        }

        // add form to form wrapper
        formWrapper.appendChild(form);

        // ---------------------------------------------- //
        // output --------------------------------------- //
        // ---------------------------------------------- //
        // add to form wrapper to output
        output.appendChild(formWrapper);

        // return output inner elements only
        return output.innerHTML;

    }

    // submit
    submit(){
    
        // selectors
        const modal = document.querySelector(`.${this.modalSelector}`),
            submitBttn = (modal) ? modal.querySelector(`#${this.submitID}`) : null;
                
        // submit bttn
        if(submitBttn){

            // add event listener
            submitBttn.addEventListener("click", this.submission.bind(this));

        // ERROR
        }else{

            // display error msg 
            console.log(`%c Error: Could not find the element using the selector: '#${this.submitID}'!!!`, 'background:#f00; color:#fff');

        }

    }

    // submit
    submission(e){

        // prevent default
        e.preventDefault();

        // check for modal and try to get form
        const modal = document.querySelector(`.${this.modalSelector}`),
            form = (modal) ? modal.getElementsByTagName("form")[0] : null,
            thisBttn = e.target;
        
        // add loading icon
        thisBttn.classList.add(this.loadingClassName);

        // get loading bar
        const thisLoadingBar = modal.querySelector(`.${this.loadingBarClassName}`);

        // make sure form is available
        if(form){

            // init form data
            const formData = new FormData();

            // get first name
            const firstName = modal.querySelector(`#${this.selectorPrefix}__fname`),
                lastName = modal.querySelector(`#${this.selectorPrefix}__lname`),
                email = modal.querySelector(`#${this.selectorPrefix}__email`),
                nonce = document.getElementById(`subscribe-check`);

            // append values
            formData.append(`${this.selectorPrefix}__fname`, (firstName) ? firstName.value : null);
            formData.append(`${this.selectorPrefix}__lname`, (lastName) ? lastName.value : null);
            formData.append(`${this.selectorPrefix}__email`, (email) ? email.value : null);
            formData.append(`wp_nonce`, (nonce) ? nonce.value : null);

            // get footer general msg area
            const footerMsg = modal.querySelector(`.${this.footerMsgSelector}`);

            // make sure footer msg area exists - or display error and die
            if(!footerMsg){

                // display error msg
                console.log(`%c Error: Could not find the element using the selector: '.${this.footerMsgSelector}'!!!`, 'background:#f00; color:#fff');
                return;

            }
            
            //reset footerMsg
            footerMsg.innerHTML = "";
            footerMsg.classList.remove(this.successClassName, this.errorClassName);

            // send ajax
            this.ajax({
                // action:"addSubscriber",                                  //go to "addSubscriber" ajax method
                action:"addToMailChimp",                                    //go to "addSubscriber" ajax method
                data:formData,                                              //form data passed
                loadingBar:(thisLoadingBar) ? thisLoadingBar : null,        //loading bar element
                loading:thisBttn                                            //bttn we clicked (to pass loading gif)
            }).then((results) => {
                
                //parse results
                results = JSON.parse(results);
                
                // SUCCESS: display success msg
                if(results.success){
                    
                    //hide form after success
                    form.classList.add(this.hideClassName);
                    
                    // add success class and msg txt
                    footerMsg.classList.add(this.successClassName);

                    // add content
                    footerMsg.textContent = results.success;

                    // focus on footerMsg
                    footerMsg.focus({preventScroll:true});

                // FAILED: display error msg
                }else{
                         
                    // make sure we have some kind of error
                    if(!results.error){

                        // display error msg
                        console.log(`%c Error: No data was received from the API.`, 'background:#f00; color:#fff');

                        // return
                        return;
                        
                    }

                    // get msg area
                    const msgArea = form.querySelectorAll(`.${this.msgSelector}`);

                    // make sure msg area exists - or display error and die
                    if((!msgArea)||(msgArea.length <= 0)){

                        // display error msg
                        console.log(`%c Error: Could not find the element using the selector: '.${this.msgSelector}'!!!`, 'background:#f00; color:#fff');
                        
                        // return
                        return;

                    }

                    // init firstError
                    let firstError = null;

                    //loop
                    msgArea.forEach((item) => {

                        // clear msg area
                        item.textContent = "";

                        // grab input
                        const input = item.parentNode.getElementsByTagName('input')[0],
                        inputID = (input) ? input.id : null,
                        thisError = (inputID) ? results.error[inputID] : null;

                        // make sure input and error exists
                        if(input && thisError){

                            // add error class
                            item.classList.add(this.errorClassName);

                            // enable screen readers to read msg
                            item.setAttribute("aria-hidden", "false");

                            // update error msg
                            item.textContent = thisError;

                            // check for an error
                            if(!firstError){

                                // set error
                                firstError = item;

                                // set focus
                                item.focus({preventScroll:true});
                                
                            }

                        }

                    });

                    // general error msg
                    if(results.error.general){
                        
                        //add error class
                        footerMsg.classList.add(this.errorClassName);

                        // append msg to msgRow
                        footerMsg.textContent = (results.error.general.title) ? results.error.general.title : "Could not add you to the subscription list.";

                        // focus    
                        footerMsg.focus({preventScroll:true});

                    }

                }

            // catch ajax error
            }).catch((err) => {

                // display msg
                console.log(`%c Error: '${err}'.`, 'background:#f00; color:#fff');

            });
            
        //ERROR:FORM    
        }else{

            // display error msg 
            console.log(`%c Error: Could not find the form element!!!`, 'background:#f00; color:#fff');
        
        }

    }

}

// export
export default Subscribe;